import { 
  FaStar,
  FaArrowRight
} from 'react-icons/fa';
import Slider1 from '../assets/images/sliders/slider-1.png'
import Slider2 from '../assets/images/sliders/slider-2.png'
import Slider3 from '../assets/images/sliders/slider-3.png'
import Slider4 from '../assets/images/sliders/slider-4.png'

export const sliderData = {
  slides: [
    {
      id: 1,
      image: Slider1,
      badge: {
        text: "CBSE Affiliated • Recognized by Government",
        icon: FaStar,
        color: "from-blue-600 to-indigo-500"
      },
      title: {
        prefix: "Admissions Open",
        highlight: "For Academic Year 2025-26",
        highlightColor: "from-blue-600 to-indigo-500"
      },
      description: "Secure your child's future with quality education from Pre-Nursery to Class 10. Limited seats available for all grades.",
      stats: [
        { value: "Limited", label: "Seats Available" },
        { value: "Early Bird", label: "Discount" },
        { value: "Online", label: "Application" }
      ],
      buttons: [
        {
          text: "Apply Now",
          gradient: "from-blue-600 to-indigo-500",
          hasIcon: true,
          icon: FaArrowRight
        },
        {
          text: "Download Brochure",
          isOutline: true
        }
      ],
      gradient: "from-blue-900/40 via-blue-800/30 to-transparent"
    },
    {
      id: 2,
      image: Slider2,
      badge: {
        text: "Promoting Cultural Heritage & Values",
        icon: FaStar,
        color: "from-purple-600 to-pink-500"
      },
      title: {
        prefix: "Celebrating Cultural",
        highlight: "Diversity & Traditions",
        highlightColor: "from-purple-600 to-pink-500"
      },
      description: "Vibrant cultural festivals, traditional celebrations, and creative arts that enrich our students' learning experience.",
      stats: [
        { value: "10+", label: "Cultural Events" },
        { value: "Traditional", label: "Celebrations" },
        { value: "Arts & Music", label: "Programs" }
      ],
      buttons: [
        {
          text: "View Gallery",
          gradient: "from-purple-600 to-pink-500",
          hasIcon: true,
          icon: FaArrowRight
        },
        {
          text: "Upcoming Events",
          isOutline: true
        }
      ],
      gradient: "from-purple-900/40 via-pink-800/30 to-transparent"
    },
    {
      id: 3,
      image: Slider3,
      badge: {
        text: "Developing Sportsmanship & Fitness",
        icon: FaStar,
        color: "from-green-600 to-emerald-500"
      },
      title: {
        prefix: "Nurturing Champions",
        highlight: "Through Sports",
        highlightColor: "from-green-600 to-emerald-500"
      },
      description: "State-of-the-art sports facilities and professional coaching for overall physical development and teamwork.",
      stats: [
        { value: "15+", label: "Sports Activities" },
        { value: "Inter-School", label: "Champions" },
        { value: "Daily", label: "Sports Period" }
      ],
      buttons: [
        {
          text: "Sports Facilities",
          gradient: "from-green-600 to-emerald-500",
          hasIcon: true,
          icon: FaArrowRight
        },
        {
          text: "Meet Coaches",
          isOutline: true
        }
      ],
      gradient: "from-green-900/40 via-emerald-800/30 to-transparent"
    },
    {
      id: 4,
      image: Slider4,
      badge: {
        text: "Eco-Friendly School • Green Award Winner",
        icon: FaStar,
        color: "from-teal-600 to-green-500"
      },
      title: {
        prefix: "Building a Greener",
        highlight: "Tomorrow Together",
        highlightColor: "from-teal-600 to-green-500"
      },
      description: "Environmental awareness programs, tree plantation drives, and eco-friendly initiatives for sustainable future.",
      stats: [
        { value: "500+", label: "Trees Planted" },
        { value: "Eco-Club", label: "Active Members" },
        { value: "Green", label: "Campus" }
      ],
      buttons: [
        {
          text: "Join Eco-Club",
          gradient: "from-teal-600 to-green-500",
          hasIcon: true,
          icon: FaArrowRight
        },
        {
          text: "Green Initiatives",
          isOutline: true
        }
      ],
      gradient: "from-teal-900/40 via-green-800/30 to-transparent"
    }
  ],
  settings: {
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1
  }
};